import type { DraftEntry } from './state/loggerDraftTypes';
import { isSetTimed } from './deriveEntryKind';

// THE rule for "completing this set raises the AMRAP question" — one function,
// read by useAmrapConfirm.shouldPrompt, which decides whether to ask. Kept as
// its own tested module: the rule is the contract, the hook only calls it.
//
// Cardio and timed sets have no AMRAP chip (FocusPanelChipRow) and no `amrap`
// field on the payload, so a prompt there would ask for something unwritable.
// The reps-open form of the test is the only one built.
// `readonly` because this only reads: it accepts a readonly or a mutable array.
export const willPromptAmrap = (
  entries: readonly DraftEntry[],
  entryIdx: number,
  setIdx: number,
): boolean => {
  const entry = entries[entryIdx];
  if (!entry) return false;
  const set = entry.sets[setIdx];
  if (!set) return false;
  if (entry.isCardio || isSetTimed(entry, set)) return false;
  return set.amrapPrescribed === true && set.amrap !== true;
};
